
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_315_35960)"}},[_c('g',{attrs:{"clip-path":"url(#clip1_315_35960)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.556 3.685A9 9 0 0121 12h-2a7 7 0 10-3.5 6.062l1 1.732A9 9 0 118.556 3.685z","fill":"#161616"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_315_35960"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_315_35960"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    